import { Record } from 'immutable';
// eslint-disable-next-line hs-react-native/no-dark-mode-incompatible-code
import { KOALA, GYPSUM } from 'HubStyleTokens/colors';
const FileAttachmentTheme = Record({
  tileBackgroundColor: GYPSUM,
  tileBorderColor: KOALA
}, 'FileAttachmentTheme');
export default FileAttachmentTheme;